/* =====================================================================
   THE ROOM ENGINE — desk-tells.js: THE PENCIL

   C0 (2026-09-18). R17 (d) put two TELLS on this desk — "one or two
   things only a desk has, cheap and quiet" — and they were two blocks of
   arithmetic inside the oak's own fragment shader, behind one `TELLS`
   switch, in a file that also held the sheet and the books. The lamp's
   base is desk-lamp.js's; the pencil is this.

   IT IS STILL PAINTED ON THE WOOD, not drawn: 175 x 7 mm of hexagonal
   lacquer in css pixels, in the pass that was already running — no mesh,
   no draw, no byte on the wire. What the `oak` hook changed is that the
   block is registered instead of written in, so the oak's shader does not
   have to know a pencil from a paperweight; what it does not change is
   one character of the arithmetic.

   `?pencil=0` takes the hexagon and its shadow out of the oak's pass
   altogether — no branch, no uniform, the arithmetic is not compiled —
   and the default is UNCHANGED: with no switch the emitted source is
   byte-for-byte what it was.
   ===================================================================== */
(function () {
'use strict';
var O = window.RoomObjects;
if (!O || !O.piece) return;

/* R58 (c): AND THE PENCIL ON ITS OWN. Tommy, 2026-09-14: "i'm actually
   unsure about the pencil anyway". `?pencil=0` takes the 175 mm hexagon
   and its shadow out of the oak's pass altogether — no branch, no
   uniform, the arithmetic is not compiled — and leaves the lamp's base
   where it is. The default is UNCHANGED: with no switch this is false
   and the shader source is byte-for-byte what it was. */
var NO_PENCIL = /[?&]pencil=0\b/.test(location.search);
var OAK_BODY = `
    /* --- the pencil ------------------------------------------------- */${NO_PENCIL ? '' : `
    vec2 pc = vec2(uFull.x + uFull.z*0.44, uFull.y + uFull.w + 34.0*mm);
    float ca = 0.9985, sa = -0.0548;                  // about three degrees
    vec2 q = vec2(dot(p - pc, vec2(ca, sa)), dot(p - pc, vec2(-sa, ca)));
    float hl = 87.0*mm, hw2 = 3.6*mm, tip = 20.0*mm;
    float taper = 1.0 - smoothstep(hl - tip, hl, q.x)*0.92;
    float wq = hw2*taper;
    float pcov = (1.0 - smoothstep(-0.9, 0.9, abs(q.y) - wq))
               * (1.0 - smoothstep(-0.9, 0.9, abs(q.x) - hl));
    /* its shadow, struck the same way and as short */
    {
      vec2 q2 = q - vec2(dot(pd*7.0, vec2(ca, sa)), dot(pd*7.0, vec2(-sa, ca)));
      float w2 = hw2*(1.0 - smoothstep(hl - tip, hl, q2.x)*0.92);
      float scov = (1.0 - smoothstep(-2.6, 2.6, abs(q2.y) - w2*1.25))
                 * (1.0 - smoothstep(-2.6, 2.6, abs(q2.x) - hl));
      col = mix(col, vec3(0.0), 0.46*ok*scov*(1.0 - pcov));
    }
    if (pcov > 0.001) {
      float t = clamp(q.y/max(wq, 0.001), -1.0, 1.0);
      /* SIX FLATS, not a cylinder: a pencil is a hexagon and the facets
         are why it never quite looks round. Three of them face the eye. */
      float fq = floor((t*0.5 + 0.5)*3.0);
      float facet = 0.78 + 0.30*(1.0 - abs(fq - 1.0));
      float across = clamp(0.5 - t*0.5*sign(lit2.y + 1e-5), 0.0, 1.0);
      float sh2 = facet*(0.52 + 0.62*across);
      vec3 lac = vec3(0.196,0.243,0.196);             // the same buckram as the field book
      vec3 pcl = lac*sh2;
      /* the sharpened end: bare cedar, and the lead */
      float cone = smoothstep(hl - tip, hl - tip + 1.5*mm, q.x);
      pcl = mix(pcl, vec3(0.66,0.52,0.34)*sh2*1.25, cone);
      float lead = smoothstep(hl - 5.0*mm, hl - 4.0*mm, q.x);
      pcl = mix(pcl, vec3(0.145,0.149,0.157)*(0.7 + 0.9*sh2), lead);
      /* the one line of light down the lacquer that says "round" */
      float gl2 = exp(-pow((t + 0.38*sign(lit2.y + 1e-5))*3.4, 2.0));
      pcl += vec3(1.0,0.96,0.88)*gl2*(0.16 + 0.22*uSun.w)*(1.0 - cone*0.6);
      col = mix(col, pcl, pcov);
    }`}
`;

O.piece('tells', function () { /* nothing is DRAWN: see the head */ }, {
  oak: { body: OAK_BODY },
  smoke: function () { return { pencil: !NO_PENCIL }; }
});
})();
